// DREZORO corporate site — brand data. Add new companies here; the grid adapts automatically.
export const DZ_BLUE = "#3B82F6";

export const COMPANIES = [
  {
    id: "vozelto", name: "VOZELTO", span: "md:col-span-8",
    tagline: "AI Operating Platform",
    blurb: "The AI Operating System for modern business — marketing, automation, and growth run by a coordinated team of AI employees.",
    image: "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGFuYWx5dGljcyUyMHRlY2hub2xvZ3klMjBkYXJrfGVufDB8fHx8MTc4NDIzNjY0MHww&ixlib=rb-4.1.0&q=85",
    sector: "Artificial Intelligence · SaaS", href: "/",
  },
  {
    id: "turnkey", name: "TurnKey Property Maintenance", span: "md:col-span-4",
    tagline: "Property Technology",
    blurb: "Enterprise property maintenance and preservation, delivered with operational precision.",
    image: "https://images.unsplash.com/photo-1567943183748-3a7542120c90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBhYnN0cmFjdHxlbnwwfHx8fDE3ODQyMzY2NDB8MA&ixlib=rb-4.1.0&q=85",
    sector: "Property Services", href: null,
  },
  {
    id: "black-ember", name: "Black Ember Coffee", span: "md:col-span-4",
    tagline: "Consumer Brand",
    blurb: "A premium coffee brand built on quality sourcing and an uncompromising customer experience.",
    image: "https://images.unsplash.com/photo-1655933146833-04a7ab9cd317?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwZXNwcmVzc28lMjBjb2ZmZWUlMjBkYXJrfGVufDB8fHx8MTc4NDIzNjY0MHww&ixlib=rb-4.1.0&q=85",
    sector: "Consumer · E-commerce", href: null,
  },
  {
    id: "operation-enough", name: "Operation Enough", span: "md:col-span-8",
    tagline: "Health & Performance",
    blurb: "Fitness, nutrition, wellness, and personal transformation — engineered for lasting results.",
    image: "https://images.unsplash.com/photo-1637430308606-86576d8fef3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBmaXRuZXNzJTIwZ3ltJTIwZGFya3xlbnwwfHx8fDE3ODQyMzY2NDB8MA&ixlib=rb-4.1.0&q=85",
    sector: "Wellness · Lifestyle", href: null,
  },
];

export const TECHNOLOGY = [
  { t: "Artificial Intelligence", d: "Production AI systems that reason, create, and act across every business function." },
  { t: "Automation", d: "Hands-free operational workflows that run around the clock with human oversight." },
  { t: "Marketing Technology", d: "Multi-channel campaign engines spanning social, email, advertising, and content." },
  { t: "Business Operations", d: "Command-center software that unifies revenue, teams, and execution." },
  { t: "Data Intelligence", d: "Analytics pipelines that turn raw commerce data into daily decisions." },
  { t: "Customer Experience", d: "Personalized journeys measured and improved at every touchpoint." },
  { t: "Cloud Software", d: "Secure, multi-tenant platforms engineered for scale and reliability." },
  { t: "AI Assistants", d: "Specialized AI employees — directors, managers, and analysts on demand." },
];

export const WHY = [
  { t: "Innovation", d: "We build ahead of the market, not behind it." },
  { t: "Security", d: "Enterprise-grade isolation, encryption, and access control by default." },
  { t: "Scalability", d: "Architecture designed for the next order of magnitude." },
  { t: "Reliability", d: "Verified publishing, audited automation, measurable uptime." },
  { t: "AI-First Design", d: "Intelligence is the foundation of every product, not a feature." },
  { t: "Customer Success", d: "Our platforms succeed only when our customers grow." },
  { t: "Enterprise Quality", d: "Hardened, tested, and validated before anything ships." },
  { t: "Long-Term Partnership", d: "We invest in decades-long relationships, not transactions." },
];

export const NEWS_FALLBACK = [
  { id: "n3", date: "2026-07-16", tag: "Announcement", title: "EmberOS becomes Vozelto — a new identity for the AI Operating System",
    body: "DREZORO's flagship platform completes its rebrand to Vozelto, unifying AI marketing, automation, and growth under a single enterprise identity." },
  { id: "n2", date: "2026-07-01", tag: "Product", title: "Vozelto ships Brand Asset Enforcement for AI-generated creative",
    body: "New safeguards guarantee that AI-generated marketing imagery uses only official product photography and approved brand assets." },
  { id: "n1", date: "2026-06-15", tag: "Company", title: "DREZORO consolidates its brand family under one innovation group",
    body: "Vozelto, TurnKey Property Maintenance, Black Ember Coffee, and Operation Enough now operate under the DREZORO parent organization." },
];

export const NAV = [
  { to: "/drezoro/about", label: "About" },
  { to: "/drezoro/companies", label: "Companies" },
  { to: "/drezoro/technology", label: "Technology" },
  { to: "/drezoro/news", label: "News" },
  { to: "/drezoro/contact", label: "Contact" },
];
